import React from 'react'
import { ReferenceField } from 'react-admin'
import { connect } from 'react-redux'
import CustomFields from '.'
import { Entity } from '@obvious.tech/constellation/Entity'

const getCustomFieldSpecificProps = (type, property) => {
  switch (type) {
    case 'Image':
      return {
        source: property.reference?.targetLabelKeyPath,
      }
    default:
      return {}
  }
}

/**
 * @param {object} param0
 * @param {import('src/types').TEntityOverrideProp} param0.property
 * @returns {JSX.Element}
 */
const CustomReferenceField = ({ name, property, entities, ...props }) => {
  const referencedEntityName = property.reference?.target
  if (!referencedEntityName) return <span />

  const referencedEntity = entities[referencedEntityName]
  const referencedField = property.reference?.targetLabelKeyPath ?? 'id'
  const referencedProperty = {
    ...referencedEntity.global.properties[referencedField],
    ...(referencedEntity.list.properties[referencedField] ?? {}),
  }

  const idKeyPath = property.reference.idKeyPath
  const source =
    idKeyPath === undefined
      ? props.source
      : idKeyPath === null
      ? name
      : `${name}.${idKeyPath}`

  return (
    <ReferenceField
      {...props}
      label={property.displayedName || name}
      reference={Entity.getResource(referencedEntityName)}
      source={source}
    >
      {React.createElement(CustomFields[referencedProperty.type], {
        label: property.displayedName ?? name,
        name: referencedField,
        property,
        ...getCustomFieldSpecificProps(referencedProperty.type, property),
      })}
    </ReferenceField>
  )
}

const mapStateToProps = state => {
  return {
    entities: state.definitions.entities,
  }
}

export default connect(mapStateToProps, null)(CustomReferenceField)
